import { useTranslation } from 'react-i18next';
import { EmploymentIncomeVerificationSource } from '../../../api/screening/findOverview';
import ScreeningOverviewStepTable from './ScreeningOverviewStepTable';
import moment from 'moment';
import styles from './ScreeningOverviewEmploymentIncomeVerificationSourceStepTable.module.css';
import { ContractTypeEnum } from '../../enums';

interface ScreeningOverviewEmploymentIncomeSourcesStepTableProps {
    data: EmploymentIncomeVerificationSource;
}

const ScreeningOverviewEmploymentIncomeVerificationSourcesStepTable = ({
    data
}: ScreeningOverviewEmploymentIncomeSourcesStepTableProps) => {
    const { t } = useTranslation();

    let contractType = data.contractType;
    if (Object.values(ContractTypeEnum).includes(contractType as ContractTypeEnum)) {
        contractType = t(`screening.overview.step.employmentIncomeVerificationSource.employment.contractType.${data.contractType}`);
    }

    const EmploymentIncomeVerificationSource = [
        {
            title: (
                <div>
                    <span className={styles.incomeSource}>
                        {t('screening.overview.step.IncomeVerificationSource.incomeSource')}</span>
                    {t(`screening.incomeVerification.incomeSourceTypeContent.type.options.${data.type}`)}
                </div>
            ),
            subSections: [
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.employer'),
                    value: data.employer
                },
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.contractType'),
                    value: contractType
                },
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.startDate'),
                    value: moment(data.startDate).format('DD-MM-YYYY')
                },
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.grossIncome'),
                    value: data.grossIncome ? data.grossIncome.toString() : null
                },
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.incomeFrequency'),
                    value: data.additionalIncomeFrequency ? t(`screening.overview.step.employmentIncomeVerificationSource.employment.income.incomeFrequency.${data?.incomeFrequency}`) : '-'
                },
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.holidayAllowanceIncluded'),
                    value: data.holidayAllowanceIncluded ? t('radio.input.true.label') : t('radio.input.false.label')
                },
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.thirteenthMonthPayIncluded'),
                    value: data.thirteenthMonthPayIncluded ? t('radio.input.true.label') : t('radio.input.false.label')
                },
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.thirtyPercentFacilityApplicable'),
                    value: data.thirtyPercentFacilityApplicable ? t('radio.input.true.label') : t('radio.input.false.label')
                },
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.additionalIncome'),
                    value: data.additionalIncome ? data.additionalIncome.toString() : null
                },
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.additionalIncomeFrequency'),
                    value: data.additionalIncomeFrequency ? t(`screening.overview.step.employmentIncomeVerificationSource.employment.income.incomeFrequency.${data?.additionalIncomeFrequency}`) : '-'
                },
                {
                    title: t('screening.overview.step.employmentIncomeVerificationSource.additionalIncomeComment'),
                    value: data.additionalIncomeComment
                },
                {
                    title: t('screening.overview.step.IncomeVerificationSource.uploadedDocuments'),
                    data: [
                        {
                            title: t('screening.overview.step.employmentIncomeVerificationSource.employmentContract.label'),
                            value: data.employmentContract
                        },
                        {
                            title: t('screening.overview.step.employmentIncomeVerificationSource.employerStatement.label'),
                            value: data.employerStatement
                        },
                        {
                            title: t('screening.overview.step.employmentIncomeVerificationSource.employmentPayslipOne.label'),
                            value: data.employmentPayslipOne
                        },
                        {
                            title: t('screening.overview.step.employmentIncomeVerificationSource.employmentPayslipTwo.label'),
                            value: data.employmentPayslipTwo
                        },
                        {
                            title: t('screening.overview.step.employmentIncomeVerificationSource.employmentPayslipThree.label'),
                            value: data.employmentPayslipThree
                        },
                    ]
                }
            ]
        }
    ];

    return (
        <ScreeningOverviewStepTable
            data={EmploymentIncomeVerificationSource}
        />
    );
}

export default ScreeningOverviewEmploymentIncomeVerificationSourcesStepTable;
